module.exports = __webpack_public_path__ + "static/media/crowd.7bd96d45.jpg";